import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

// INFO (Denis) - an admin without a selected company only has system content (instructions and templates), so every other company page sends them to the admin dashboard
export const companySelectedGuard: CanActivateChildFn = () =>
  inject(AuthService).isSystemContext() ? inject(Router).createUrlTree(['/app', 'admin', 'dashboard']) : true;
